import React from 'react';
import { FormikProps } from 'formik';
import { Grid } from '@mui/material';
import AppFormSelectWrapper from '../../../components/designe/app-form-select-wrapper';
import { useTranslation } from 'react-i18next';

interface IExercisePropertiesFilterProps {
  formik: FormikProps<any>;
  filterParentOptions: Array<{ id: string; name: string }>;
  filterTypeOptions: Array<{ id: string; name: string }>;
  filterActiveTranslationOptions: Array<{
    id: string | boolean;
    name: string;
  }>;
}

export function ExercisePropertiesFilter(
  props: IExercisePropertiesFilterProps,
) {
  const {
    formik,
    filterParentOptions,
    filterTypeOptions,
    filterActiveTranslationOptions,
  } = props;
  const { t } = useTranslation();

  return (
    <Grid container spacing={1}>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.parent')}
          name="parent"
          options={filterParentOptions}
          disableClear={false}
          formik={formik}></AppFormSelectWrapper>
      </Grid>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.type')}
          name="type"
          options={filterTypeOptions}
          disableClear={false}
          formik={formik}></AppFormSelectWrapper>
      </Grid>
      <Grid item sm={4}>
        <AppFormSelectWrapper
          label={t('common.active')}
          name="active"
          options={filterActiveTranslationOptions}
          disableClear={false}
          formik={formik}></AppFormSelectWrapper>
      </Grid>
    </Grid>
  );
}
